<template>
  <v-row class="color py-10">
    <div v-if="$vuetify.breakpoint.lgAndUp">
      <v-row class="mx-0">
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
          xl="4"
          class="justify-end align-center d-flex flex-column"
        >
          <v-img
            height="100"
            width="100"
            contain
            :src="`${publicPath}images/iconos/s-avalados.png`"
          ></v-img>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
          xl="4"
          class="justify-start align-center d-flex flex-column"
        >
          <v-img
            height="100"
            width="100"
            contain
            :src="`${publicPath}images/iconos/s-horarios.png`"
          ></v-img>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
          xl="4"
          class="justify-start align-center d-flex flex-column"
        >
          <v-img
            height="100"
            width="100"
            contain
            :src="`${publicPath}images/iconos/s-compatibilidad.png`"
          ></v-img>
        </v-col>
      </v-row>
      <v-row class="mx-0">
        <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="align-center d-flex flex-column">
          <h3 class="text-center white--text text-uppercase mt-10">Tus estudios están avalados</h3>
          <p
            class="text-center white--text px-6"
          >Tendrás la seguridad de que tu licenciatura está avalada por la Secretaría de Educación Pública.</p>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="align-center d-flex flex-column">
          <h3 class="text-center white--text text-uppercase mt-10">Flexibilidad de horarios</h3>
          <p
            class="text-center white--text px-6"
          >Podrás trabajar y estudiar sin desplazarte a otro lugar, desde casa e incluso cuando sales de viaje. La flexibilidad te permite estudiar donde estés y en el horario que se te facilite. No es necesario asistir a clases y horarios fijos.</p>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="align-center d-flex flex-column">
          <h3 class="text-center white--text text-uppercase mt-10">Compatibilidad laboral y familiar</h3>
          <p
            class="text-center white--text px-6"
          >Podrás armonizar tus actividades escolares y compromisos familiares y laborales, porque tu organizas tus tiempos de estudio.</p>
        </v-col>
      </v-row>
    </div>
    <!---->
    <div v-else>
      <v-layout
        :row="$vuetify.breakpoint.mdAndUp"
        :column="$vuetify.breakpoint.smAndDown"
        :justify-center="$vuetify.breakpoint.mdAndDown"
        mt-10
      >
        <v-flex xs12 sm12 md6 lg4 d-flex class="justify-center align-center flex-column">
          <v-img
            height="100"
            width="100"
            contain
            :src="`${publicPath}images/iconos/s-avalados.png`"
          ></v-img>
          <h3 class="text-center white--text text-uppercase mt-10">Tus estudios estan avalados</h3>
          <p
            class="text-center white--text px-6"
          >Tendrás la seguridad de que tu licenciatura esta avalada por la Secretaría de Educación Pública.</p>
        </v-flex>
        <v-flex xs12 sm12 md6 lg4 d-flex class="justify-center align-center flex-column">
          <v-img height="80" width="80" contain :src="`${publicPath}images/iconos/s-horarios.png`"></v-img>
          <h3 class="text-center white--text text-uppercase mt-10">Flexibilidad de horarios</h3>
          <p
            class="text-center white--text px-6"
          >Podrás trabajar y estudiar sin desplazarte a otro lugar, desde casa e incluso cuando sales de viaje. La flexibilidad te permite estudiar dondé estés y en el horario que se te facilite. No es necesario asistir a clases y horarios fijos.</p>
        </v-flex>
        <v-flex xs12 sm12 md6 lg4 d-flex class="justify-center align-center flex-column">
          <v-img
            height="100"
            width="100"
            contain
            :src="`${publicPath}images/iconos/s-compatibilidad.png`"
          ></v-img>
          <h3 class="text-center white--text text-uppercase mt-10">Compatibilidad laboral y familiar</h3>
          <p
            class="text-center white--text px-6"
          >Podrás armonizar tus actividades escolares y compromisos familiares y laborales, porque tu organizas tus tiempos de estudio.</p>
        </v-flex>
      </v-layout>
    </div>
  </v-row>
</template>
<style lang="scss" scoped>
.color {
  background-color: rgb(43, 43, 43) !important;
}
</style>
<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>